// extracted by mini-css-extract-plugin
export default {"app":"app__Di-3m","text-center":"text-center__QdbfH","error-color":"error-color__8yFc7","loading":"loading__Coqgg","wrapper":"wrapper__zzw4m"};